// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__fJfIz","separator":"Navbar_separator__i4gjU","activeLink":"Navbar_activeLink__RJyr3","loading":"Navbar_loading__OMiBj"};